export {
  BREADCRUMB_TOOLTIP_CLASS_NAME,
  TruncatedText,
  type TruncatedTextProps,
} from "./components/TruncatedText/TruncatedText"
